import {
  TEXT_POOL,
  TEXT_POOL_INSET,
  haloBackground,
} from '@roomtreatment/design'

/**
 * The field fading out around a block of copy — the hero's cloud, not a shape.
 *
 * Same ellipse-and-smoothstep as `FieldHalo`, sized relative to the block by
 * `TEXT_POOL_INSET` (geometry and its two failed predecessors: plate.ts). The
 * gradient is used as a MASK over a flat `--field-ground` rather than painted
 * directly, because a field section's ground is the page tinted toward paper
 * and only CSS knows that colour.
 *
 * Callers: first child of a `relative` block; give the text `relative` so it
 * paints above. The pool sits at `-z-10` so a wide one cannot grey out a
 * NEIGHBOURING block's words; FieldSection's `isolate` contains that index so
 * it stays above the field rather than dropping behind it.
 */
export default function FieldFade() {
  const shape = haloBackground(TEXT_POOL, '0, 0, 0')
  return (
    <div
      aria-hidden
      data-field-plate=""
      className="pointer-events-none absolute -z-10"
      style={{
        left: TEXT_POOL_INSET.x,
        right: TEXT_POOL_INSET.x,
        top: TEXT_POOL_INSET.y,
        bottom: TEXT_POOL_INSET.y,
        background: 'var(--field-ground, var(--rt-page))',
        maskImage: shape.backgroundImage,
        WebkitMaskImage: shape.backgroundImage,
        maskSize: shape.backgroundSize,
        WebkitMaskSize: shape.backgroundSize,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
      }}
    />
  )
}
